import { render, staticRenderFns } from "./RevokeTable.vue?vue&type=template&id=8ae201d0&scoped=true&"
import script from "./RevokeTable.vue?vue&type=script&lang=js&"
export * from "./RevokeTable.vue?vue&type=script&lang=js&"
import style0 from "./RevokeTable.vue?vue&type=style&index=0&id=8ae201d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae201d0",
  null
  
)

export default component.exports